import { createActions, handleActions, Action } from "redux-actions";
import { Services } from "~api/services";

interface Localidad {
  label: string;
  value: string;
}

interface FetchLocalidadesCompletedPayload {
  value: Localidad[];
}

interface LocalidadSelectorState {
  localidades: Localidad[];
  isLoading: boolean;
}

const {
  business: {
    localidades: {
      fetchLocalidadesInited,
      fetchLocalidadesCompleted,
      fetchLocalidadesFailed,
    },
  },
} = createActions({
  business: {
    localidades: {
      fetchLocalidadesInited: () => ({}),
      fetchLocalidadesCompleted: (value: Localidad[]) => ({ value }),
      fetchLocalidadesFailed: (error: any) => ({ error }),
    },
  },
});

const fetchLocalidades = (provinciaId: string) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(fetchLocalidadesInited());
      const response = await services.api
        .provincias()
        .getLocalidades(provinciaId);

      const localidades: Localidad[] = response.localidades
        .filter((v: string, i: number) => response.localidades.indexOf(v) === i)
        .filter((i: string) => i !== "")
        .map((item: string) => ({
          value: item,
          label: item,
        }));
      dispatch(fetchLocalidadesCompleted(localidades));
    } catch (error) {
      console.error(error);
      dispatch(fetchLocalidadesFailed(error));
    }
  };
};

const initialState: LocalidadSelectorState = {
  localidades: [],
  isLoading: false,
};

const localidadSelectorReducer = handleActions<LocalidadSelectorState, any>(
  {
    [fetchLocalidadesInited.toString()]: (): LocalidadSelectorState => ({
      ...initialState,
      isLoading: true,
    }),
    [fetchLocalidadesCompleted.toString()]: (
      _state: LocalidadSelectorState,
      action: Action<FetchLocalidadesCompletedPayload>
    ): LocalidadSelectorState => ({
      ...initialState,
      localidades: action.payload.value,
      isLoading: false,
    }),
    [fetchLocalidadesFailed.toString()]: (): LocalidadSelectorState => ({
      ...initialState,
      isLoading: false,
    }),
  },
  initialState
);

export default localidadSelectorReducer;
export {
  fetchLocalidadesInited,
  fetchLocalidadesCompleted,
  fetchLocalidadesFailed,
  fetchLocalidades,
};
